import { render } from "./Payments.vue?vue&type=template&id=9584ec8e&scoped=true"
import script from "./Payments.vue?vue&type=script&lang=js"
export * from "./Payments.vue?vue&type=script&lang=js"

import "./Payments.vue?vue&type=style&index=0&id=9584ec8e&scoped=true&lang=css"
import "./Payments.vue?vue&type=style&index=1&id=9584ec8e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9584ec8e"]])

export default __exports__